import React from "react";
import hand from "../../assets/static/hand like.svg";
import "../../assets/styles/Modals/finishedModal.sass";

const FinishedModalOnlyApp = ({ title, link, buttonTitle, setCloseModal,closeModal, sub_title}) => {
  return (
    <>
      <div className={closeModal ? "modalActive" : "modalNone"}>
        <div className="modalActive__modal">
          <div className="modalActive__modal__container" style={{ width:'100%', height:'100%'}} >
            {/* <button
              className="modalActive__modal__container__close"
              onClick={setCloseModal}
            >
              <img
                alt="icon"
                className="modalActive__modal__container__close__img"
                src={close}
              />
            </button> */}
            <img
              alt="icon"
              className="modalActive__modal__container__close__hand"
              src={hand}
            />
            <h2 className="modalActive__modal__container__title">
              ¡Excelente!
            </h2>
            {/* <p className='modalActive__modal__container__description'>Publicaste tu Alohamiento y estas listo para recibir tus próximos huéspedes.</p> */}
            <p className="modalActive__modal__container__description">
              {title}
            </p>
            <div style={{height:10}}></div>
            <p className="modalActive__modal__container__description">
              {sub_title}
            </p>
            {/* <Link className="modalActive__modal__container__link" to={link}>
              <img
                alt="icon"
                className="modalActive__modal__container__link__icon"
                src={arrowLeft}
              />
              {buttonTitle}
            </Link> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default FinishedModalOnlyApp;
